export default __webpack_public_path__ + "static/media/case-study4.ec72e60c.jpg";